"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAlgoliaContext = void 0;
const react_1 = require("react");
const createAlgoliaContext = () => {
    return (0, react_1.createContext)(undefined);
};
exports.createAlgoliaContext = createAlgoliaContext;
//# sourceMappingURL=createAlgoliaContext.js.map